import { type PID } from '@fs/zion-tree-types'
import { pidRegexStr } from '@fs/zion-pid'

export const NOTES_ROUTE_PATH = `/notes/:pid(${pidRegexStr as PID})` as const
